import React from "react";
import Header from "./Header";
import SubscriptionComponent from "../utils/SubscriptionComponent";
import ExploreSection from "../home/ExploreSection";
import WhyLoveSection from "../home/WhyLoveSection";
import HowSection from "../home/HowSection";
import EvidenceSection from "../home/EvidenceSection";
import UnderstandSection from "../home/UnderstandSection";
import PlanSection from "../home/PlanSection";
import LibrarySection from "../home/LibrarySection";
import SEO from "../utils/SEO";
import { organizationSchema } from "../../config/eeat";

function HomePage() {
  return (
    <main>
      <SEO
        title="Sarv - Personalized Herbal Medicine & Holistic Health Recommendations"
        description="Get personalized herbal medicine recommendations tailored to your body. Sarv analyzes your health profile to suggest natural remedies for anxiety, sleep, weight loss, diabetes, and more."
        canonicalPath="/"
        keywords="personalized herbal medicine, holistic health app, natural remedies, medicinal herbs, Ayurveda, naturopathy, herbal wellness, Chinese medicine, holistic healthcare platform"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema()),
        }}
      />
      <Header />
      {/* Order is the argument, in this sequence deliberately:
          hook → let them touch the data → what they'll actually understand →
          why we differ → who says so → how it becomes theirs → the offer.
          UnderstandSection sits second because "what do I get out of this" has
          to land before the credibility case means anything. The ask comes last
          because everything above it is what earns it.
          The standalone pregnancy/breastfeeding section was removed: strong,
          but narrow, and it spoke to a small share of visitors. Its general
          form is now a line in WhyLoveSection. */}
      <ExploreSection />
      <UnderstandSection />
      <WhyLoveSection />
      <EvidenceSection />
      <HowSection />
      <PlanSection />
      <LibrarySection />
      {/* Shared with the light article pages, so it is skinned dark HERE only
          rather than by changing the component — otherwise it would render as
          a white band between the dark page and the navy footer. */}
      <div className="sv-dark home-subscribe">
        <SubscriptionComponent />
      </div>
    </main>
  );
}

export default HomePage;
